import React from 'react';
import { Button, FormControl, InputGroup, DropdownButton, Dropdown, Form } from 'react-bootstrap';
import { FaSearch, FaTimes, FaUser, FaBuilding } from 'react-icons/fa';
import Select from 'react-select';

const tipoFiltroExtra = {
  departamento: { label: 'Depto.', placeholder: 'Selecione o departamento...' },
  grupo: { label: 'Grupo', placeholder: 'Selecione o grupo...' },
};

const SearchBar = ({
  isUser,
  podeVerClientes,
  apenasClientes,
  searchTerm,
  modoBusca,
  onModeChange,
  onModoBuscaChange,
  onSearchTermChange,
  onBuscar,
  onKeyPress,
  onLimpar,
  departamentos,
  grupos,
  filtroDepartamento,
  filtroGrupo,
  onFiltroDepartamentoChange,
  onFiltroGrupoChange,
  incluirInativos,
  onIncluirInativosChange,
  children,
}) => {
  const tipoExtra = tipoFiltroExtra[modoBusca] || tipoFiltroExtra.departamento;
  const isGrupo = modoBusca === 'grupo';

  const optionsDepartamentos = (departamentos || []).map((d) => ({
    value: d.codigo,
    label: `${d.codigo} - ${d.descricao}`,
  }));

  const optionsGrupos = (grupos || []).map((g) => ({
    value: g.codigo,
    label: `${g.codigo} - ${g.nome}`,
  }));

  const inputHeight = 38;

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: inputHeight,
      height: inputHeight,
      fontSize: '0.9rem',
      borderRadius: '8px 0 0 8px',
      border: '1px solid #d0d5dd',
      boxShadow: 'none',
    }),
    valueContainer: (base) => ({
      ...base,
      height: inputHeight,
      padding: '0 14px',
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: inputHeight,
    }),
    menu: (base) => ({ ...base, zIndex: 10, borderRadius: '8px' }),
  };

  const pillBtnStyle = (active) => ({
    border: 'none',
    borderRadius: '50px',
    padding: '6px 24px',
    fontSize: '0.85rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    backgroundColor: active ? '#0747a6' : 'transparent',
    color: active ? '#fff' : '#666',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  });

  const renderBlocoA = () => (
    <InputGroup className="ca-bloco-a" style={{ flex: '1 1 260px', minWidth: 0, maxWidth: 420 }}>
      <div style={{ flex: 1, position: 'relative' }}>
        <FormControl
          placeholder={isUser ? 'Código, login, email ou nome' : 'CPF, GE/Conta, email ou nome'}
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          onKeyPress={onKeyPress}
          style={{
            fontSize: '0.9rem',
            padding: '0 ' + (searchTerm ? '32px' : '14px') + ' 0 14px',
            height: inputHeight + 'px',
            borderRadius: '8px 0 0 8px',
            border: '1px solid #d0d5dd',
          }}
        />
        {searchTerm && (
          <button
            onClick={onLimpar}
            style={{
              position: 'absolute',
              right: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              color: '#999',
              fontSize: '0.8rem',
              cursor: 'pointer',
              padding: '2px 4px',
              lineHeight: 1,
              zIndex: 2,
            }}
            title="Limpar"
          >
            <FaTimes />
          </button>
        )}
      </div>
      <InputGroup.Append>
        <Button
          variant="primary"
          onClick={onBuscar}
          style={{
            padding: '0 14px',
            borderRadius: '0 8px 8px 0',
          }}
        >
          <FaSearch />
        </Button>
      </InputGroup.Append>
    </InputGroup>
  );

  const renderBlocoB = () => {
    const options = isGrupo ? optionsGrupos : optionsDepartamentos;
    const value = isGrupo ? filtroGrupo : filtroDepartamento;
    const onChange = (val) => {
      if (isGrupo) {
        onFiltroGrupoChange(val);
      } else {
        onFiltroDepartamentoChange(val);
      }
      if (val) onBuscar();
    };

    return (
      <InputGroup className="ca-bloco-b" style={{ flex: '1 1 260px', minWidth: 0, maxWidth: 420 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Select
            placeholder={tipoExtra.placeholder}
            options={options}
            value={value}
            onChange={onChange}
            isClearable
            styles={selectStyles}
            noOptionsMessage={() =>
              isGrupo ? 'Nenhum grupo' : 'Nenhum departamento'
            }
          />
        </div>
        <DropdownButton
          as={InputGroup.Append}
          alignRight
          variant="outline-secondary"
          title={tipoExtra.label}
          id="consulta-acesso-tipo-filtro"
          style={{ fontFamily: 'Open Sans, Arial, sans-serif' }}
        >
          {Object.keys(tipoFiltroExtra).map((key) => (
            <Dropdown.Item
              key={key}
              active={modoBusca === key}
              onClick={() => {
                if (key !== modoBusca) {
                  onModoBuscaChange(key);
                }
              }}
            >
              {tipoFiltroExtra[key].label}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </InputGroup>
    );
  };

  return (
    <div>
      <style>{`
        .ca-search-wrapper {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          row-gap: 12px;
          align-items: center;
          justify-content: center;
        }
        .ca-pill-wrap {
          order: 0;
          width: 100%;
          display: flex;
          justify-content: center;
          flex-shrink: 0;
        }
        .ca-bloco-a { order: 1; }
        .ca-bloco-b { order: 2; }
        .ca-switch-inativos { order: 3; }
        .ca-pill-toggle {
          background-color: #eef1f5;
          border-radius: 50px;
          padding: 3px;
          display: inline-flex;
        }
        @media (max-width: 768px) {
          .ca-bloco-a {
            flex: 1 1 100% !important;
            max-width: 100% !important;
            min-width: 0;
          }
          .ca-bloco-b {
            flex: 1 1 100% !important;
            max-width: 100% !important;
          }
          .consulta-acesso-pill-toggle button {
            padding: 6px 16px !important;
            font-size: 0.82rem !important;
          }
        }
      `}</style>
      <div className="ca-search-wrapper">
        {podeVerClientes && !apenasClientes && (
          <div className="ca-pill-wrap">
            <div className="ca-pill-toggle consulta-acesso-pill-toggle">
              <button
                style={pillBtnStyle(isUser)}
                onClick={() => onModeChange(true)}
              >
                <FaUser style={{ fontSize: '11px' }} /> Usuário
              </button>
              <button
                style={pillBtnStyle(!isUser)}
                onClick={() => onModeChange(false)}
              >
                <FaBuilding style={{ fontSize: '11px' }} /> Cliente
              </button>
            </div>
          </div>
        )}

        {renderBlocoA()}

        {isUser && renderBlocoB()}

        {isUser && (
          <div className="ca-switch-inativos" style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <Form.Check
              type="switch"
              id="consulta-acesso-incluir-inativos"
              label="Incluir inativos"
              checked={!!incluirInativos}
              onChange={(e) => onIncluirInativosChange(e.target.checked)}
              style={{ fontSize: '0.82rem', color: '#4a5568', userSelect: 'none' }}
            />
          </div>
        )}

        {children}
      </div>
    </div>
  );
};

export default SearchBar;
